var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('EntityForm',{attrs:{"initialValues":_vm.initialValues,"onCancel":_vm.handleCancel,"onSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between flex-wrap"},[_c('h3',{staticClass:"title mb-6"},[_vm._v("Nieuw kanaal toevoegen")])])
}]

export { render, staticRenderFns }